import React from 'react';
import { ChatMessageResponseCard } from '../../../types/ChatMessageResponse';

interface ResponseCardsProps {
  cards: ChatMessageResponseCard[];
}

function ResponseCards({
  cards
}: Readonly<ResponseCardsProps>): React.ReactElement | null {
  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <div className='flex justify-start mt-1'>
      <div className='flex flex-wrap gap-1.5 max-w-[70%]'>
        {cards.map((card, index) => (
          <span
            key={`${card.displayText}-${index}`}
            className={[
              'inline-flex items-center min-h-6 px-3 py-1 rounded-full text-xs leading-4',
              'border border-brand-secondary text-brand-secondary bg-white'
            ].join(' ')}
          >
            {card.displayText}
          </span>
        ))}
      </div>
    </div>
  );
}

export default ResponseCards;
